import { toast } from 'react-toastify';

// Centralized fetch wrapper. On a 403 (authorization denied) it surfaces a clear
// toast so a denied action never fails silently — the graceful safety net for
// read-only users who reach a write endpoint that wasn't gated in the UI. The
// error is still thrown so callers can handle it too.
let lastForbiddenAt = 0;

export default async function requestHandler(url, requestDetail = { method: "GET", headers: { "Content-Type": "application/json" } }) {
    try {
        const response = await fetch(url, requestDetail);
        const jsonRes = await response.json();
        if (!response.ok) {
            const error = {
                status: response.status,
                statusText: response.statusText,
                message: jsonRes.message || 'Request failed',
            };
            if (response.status === 403) {
                // De-dupe bursts (e.g. a page firing several writes at once).
                const now = Date.now();
                if (now - lastForbiddenAt > 1500) {
                    lastForbiddenAt = now;
                    toast.error(
                        error.message && error.message !== 'Forbidden'
                            ? error.message
                            : "You don't have permission to perform this action.",
                    );
                }
            }
            throw error;
        }
        return jsonRes;
    } catch (error) {
        const defaultError = {
            status: 500,
            statusText: 'Internal Server Error',
            message: 'An error occurred',
        };
        const combinedError = { ...defaultError, ...error };
        throw combinedError;
    }
}
